module.exports = __webpack_public_path__ + "img/splbg.c46c8fc5.png";